export default __webpack_public_path__ + "static/media/4.d0f1ef89.png";